import { formatEmptyValue } from '../../../../utils/common'
import RadioButton from '../../../common/RadioButton'

const SearchResultRows = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center w-full py-2 border-b border-gray-500 text-black text-sm">
      <div className="flex flex-row w-full">
        <div className="flex w-1/12 pl-1 items-center table_text">
          <RadioButton
            name={`global-search-row-checkbox`}
            value={props.selectedSectionRecord?.name === props?.name}
            checked={props.selectedSectionRecord?.name === props?.name}
            onChange={() => {
              props.onSelect()
            }}
          />
        </div>
        <div className="flex w-3/12 pl-2 items-center table_text">
          {formatEmptyValue(props?.name)}
        </div>
        <div className="flex w-3/12 pl-6 items-center table_text">
          {formatEmptyValue(props?.alias)}
        </div>
        <div className="flex w-5/12 pl-6 items-center table_text">
          {formatEmptyValue(props?.description)}
        </div>
      </div>
    </div>
  )
}
export default SearchResultRows
